module.exports = "<div class=\"confirm cBudget\"  ><!-- [ngStyle]=\"{display: display}\" [ngClass]=\"class\"-->\n        <div class=\"confirm-switch cBudget\">\n            <p class='cBudget' [textContent]=\"text\"></p>\n            <div class=\"confirm-fon cBudget\">\n                <button class='cBudget' (click)=\"Confirm()\">Yes</button>\n                <button class='cBudget' (click)=\"Cancel()\">No</button>\n            </div>\n        </div>\n    \n    </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/budget/confirm-budget/confirm-budget.component.html
// module id = ./src/app/components/budget/confirm-budget/confirm-budget.component.html
// module chunks = main